import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslationDomainService } from '@app/translation/domain/translation-domain.service';
import { SupportedLanguage } from '@app/utils/constants/supported-languages';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ParamTranslationResolver implements Resolve<string | undefined> {
  constructor(
    private translationDomainService: TranslationDomainService,
    private router: Router,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<string> | undefined {
    const language: SupportedLanguage = route.params['lang'];
    if (!this.translationDomainService.isLanguageSupported(language)) {
      this.router.navigate(['/not-found']);
      return;
    }

    this.translationDomainService.setActiveLanguage(language);

    // Activation waits for the translation file. Unlike the trip and user resolvers this one has no
    // HTTP call of its own, so without the wait the route activates before Transloco holds the
    // language, and a synchronous `translate()` off the critical path returns the raw key — as
    // ExperienceMapperApiService does when it formats a duration, storing that key in the model
    // where no later language load can re-render it.
    return this.translationDomainService.loadTranslations$(language).pipe(
      // A failed fetch still activates the route: untranslated text is the pre-existing behaviour
      // and beats blocking navigation outright.
      catchError(() => of(undefined)),
      map(() => language),
    );
  }
}
